export const RouteError = () => {
  return (
    <div>
      <h1>Oops! Page not found.</h1>
      <p>We couldn't find the page you are looking for.</p>
      <a href="/">Go to Home</a>
    </div>
  );
};
